import { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { LAST_SUBSCRIPTION_EXPIRY_REMINDER } from "constants/storages"
import { DIALOG_KEYS } from "constants/dialogKeys"
import { getDaysUntil } from "utils/dateUtils"
import { enqueueGlobalDialog } from "appRedux/slices/globalSlice"

type SubscriptionExpiryReminderOptions = {
  expiryDate: string | Date;
  daysBefore?: number;
  storageKey?: string;
}

export default function useSubscriptionExpiryReminder(props: SubscriptionExpiryReminderOptions) {
  const { expiryDate, daysBefore = 7, storageKey = LAST_SUBSCRIPTION_EXPIRY_REMINDER } = props

  const [showReminder, setShowReminder] = useState<boolean>(false)
  const [remainingDays, setRemainingDays] = useState(0)

  const hasRun = useRef(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!expiryDate || hasRun.current) return
    hasRun.current = true
    setTimeout(() => {
      calculateRemainingDays()
    }, 1000)
  }, [expiryDate, daysBefore, storageKey])

  function calculateRemainingDays() {
    const diffDays = getDaysUntil(new Date(), expiryDate)
    setRemainingDays(diffDays)

    if (diffDays > 0 && diffDays <= daysBefore) {
      const lastReminder = localStorage.getItem(storageKey)
      const lastReminderTime = lastReminder ? new Date(lastReminder).getTime() : 0
      const now = Date.now()
      const oneDay = 1000 * 60 * 60 * 24

      if (now - lastReminderTime >= oneDay) {
        setShowReminder(true)
        dispatch(enqueueGlobalDialog(DIALOG_KEYS.SUBSCRIPTION_REMINDER))
        localStorage.setItem(storageKey, new Date().toISOString())
      }
    }
  }

  return { showReminder, remainingDays, setShowReminder }
}
